import { render, staticRenderFns } from "./EventStudentEditor.vue?vue&type=template&id=4d616536"
import script from "./EventStudentEditor.vue?vue&type=script&lang=js"
export * from "./EventStudentEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports